import { Stack } from "@mantine/core";
import { useEffect, useMemo, useRef } from "react";
import { type ChatTask, selectChatAutopilot, selectChatNeglection, useChatStore } from "@/sdk/agent/chat";

import { ChatAlertBanner } from "./ChatAlertBanner/ChatAlertBanner";
import { MessageInput } from "./ChatMessageInput/MessageInput";
import MessageList from "./ChatMessages/MessageList";
import { getChatVariant } from "./ChatQueue/variants";

export default function ChatMessagesContainer({ activeChatTask }: { activeChatTask: ChatTask }) {
    const messageListViewport = useRef<HTMLDivElement>(null);
    //TODO: revisit this - is this the best way to get closeReason reactively?
    const closeReason = useChatStore((state) => state.getCloseReason(activeChatTask.chatId));

    // Subscribe to neglection and autopilot state to trigger re-renders
    const neglectionState = useChatStore(selectChatNeglection(activeChatTask.chatId));
    const autopilotState = useChatStore(selectChatAutopilot(activeChatTask.chatId));

    // Recalculate variant when neglection or autopilot state changes
    // oxlint-disable-next-line exhaustive-deps -- intentional: these trigger recalculation even though getChatVariant reads from the task
    const variant = useMemo(() => getChatVariant(activeChatTask), [activeChatTask, neglectionState, autopilotState]);

    useEffect(() => {
        if (messageListViewport.current) {
            messageListViewport.current.scrollTop = messageListViewport.current.scrollHeight;
        }
    }, [variant, closeReason]);

    return (
        <Stack
            h="100%"
            flex={1}
            pb="sm"
            pl="sm"
            pr="sm"
            justify="flex-end"
            w="100%"
            maw="55rem"
            gap="0"
            style={{ overflow: "hidden" }}
        >
            <MessageList
                key={`msg-list-${activeChatTask.id}`}
                chatTask={activeChatTask}
                viewportRef={messageListViewport}
            />
            <ChatAlertBanner variant={variant} />
            <MessageInput
                key={`msg-input-${activeChatTask.chatId}`}
                chatId={activeChatTask.chatId}
                chatTask={activeChatTask}
                scrollViewportRef={messageListViewport}
            />
        </Stack>
    );
}
